import React from 'react';
import { QRCode } from 'antd';
import { IOrder } from '@/interfaces/order';
import { DetailItem } from '@/components/dataItem/data-view-item';
import { useSetting } from '@/contexts/CompanyContext';
import { formatNumber } from '@/utils/dataUtils';
import {
  generateQRCodePaymentValue,
  isValidateQRCode,
} from '@/utils/qrCodeUtils';

interface IProps {
  data: IOrder;
}

const OrderReceiveQr = ({ data }: IProps) => {
  const { setting } = useSetting();
  // Generate the QR Code data

  const isValidate = isValidateQRCode(
    setting?.companyBillerId,
    setting?.referenceCode,
    data?.customer?.code,
    data?.ivNo,
  );
  const qrCode = generateQRCodePaymentValue(
    setting?.companyBillerId,
    setting?.referenceCode,
    data?.customer?.code,
    data?.ivNo,
    data?.summary || 0,
  );
  return (
    <>
      <div className="flex gap-3">
        <div className="min-w-[200px]">
          {(isValidate && <QRCode value={qrCode} />) || (
            <div className="border rounded items-center flex py-9 justify-center">
              NO QRCODE
            </div>
          )}
        </div>
        <div>
          <DetailItem
            customLabelClass="md:min-w-[180px]"
            label="BillerId"
            detail={setting?.companyBillerId}
          />
          {/* <DetailItem
            customLabelClass="md:min-w-[180px]"
            label="Ref 1"
            detail={setting?.referenceCode}
          />
          <DetailItem
            customLabelClass="md:min-w-[180px]"
            label="Ref 2 (Cuscode|IV No.)"
            detail={`${data?.customer?.code}|${data?.ivNo || ''}`}
          /> */}
          <DetailItem
            customLabelClass="md:min-w-[180px]"
            label="Amount"
            detail={`${formatNumber(data?.summary)} บาท`}
          />
        </div>
      </div>
    </>
  );
};

export default OrderReceiveQr;
